export function csrfToken(): string {
  // Prefer the `XSRF-TOKEN` cookie: inertia_rails refreshes it on every response, so it stays
  // valid after Devise rotates the token on login. The <meta> tag is only written on a full HTML
  // load and goes stale after an Inertia sign-in, which used to 422 the first fetch mutation.
  const cookie = document.cookie.split("; ").find((c) => c.startsWith("XSRF-TOKEN="));
  if (cookie) return decodeURIComponent(cookie.slice("XSRF-TOKEN=".length));
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}
